import Typography from "@portal/components/atoms/v2/typography";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { IAnnualResultProps } from "../types";

export const FeesOverview = ({ isDefaultLanguage, managmentFee, depotFee, summedFee }: IAnnualResultProps) => {
  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;

  return (
    <div className="flex flex-col my-3 p-3 border dark:border-blueBorderDark rounded-md bg-pageBoxBackgroundLight dark:bg-pageBoxBackgroundDark">
      <div className="flex w-full flex-row justify-between">
        <Typography variant="Bold">{texts.PAGE_15_ANNUAL_2}</Typography>
        <Typography variant="Bold">{texts.PAGE_15_PERCENTAGE}</Typography>
      </div>

      <div className="flex w-full flex-row justify-between">
        <Typography>{texts.PAGE_15_COMMISIONER}</Typography>
        <Typography>{managmentFee?.toFixed(2)}%</Typography>
      </div>

      <div className="flex w-full flex-row justify-between">
        <Typography>{texts.PAGE_15_TRANSACTION_COST}</Typography>
        <Typography>{0}%</Typography>
      </div>

      <div className="flex w-full flex-row justify-between">
        <Typography>{texts.PAGE_15_COST_BANK}</Typography>
        <Typography>{depotFee?.toFixed(2)}%</Typography>
      </div>

      <div className="flex w-full flex-row justify-between">
        <Typography>{texts.PAGE_15_TOTAL}</Typography>
        <Typography>{summedFee?.toFixed(2)}%</Typography>
      </div>
    </div>
  );
};
